"use client"; 

export default function GlobalError({error}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  console.log("Global error", error);
  return (
    <html>
      <body>
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginTop: "100px" }}>
          <h1 style={{ fontSize: "1.25rem", marginBottom: "0.5rem" }}>
            Oops, something went wrong!
          </h1>
        </div>
      </body>
    </html>
  );
}
